// // import logo from './logo.svg';
// // import './styles/global.css';

// // function App() {
// //   return (
// //     <div className="App">
// //       <header className="App-header">
// //         <img src={logo} className="App-logo" alt="logo" />
// //         <p>
// //           Edit <code>src/App.js</code> and save to reload.
// //         </p>
// //         <a
// //           className="App-link"
// //           href="https://reactjs.org"
// //           target="_blank"
// //           rel="noopener noreferrer"
// //         >
// //           Learn React
// //         </a>
// //       </header>
// //     </div>
// //   );
// // }

// // export default App;



// import React from 'react';
// import { Routes, Route, Navigate } from 'react-router-dom';
// import { useAuth } from './context/AuthContext';
// import Login from './components/Login/Login';
// import Dashboard from './components/Dashboard/Dashboard';
// import AdminLayout from './components/Layouts/AdminLayout';
// import ManageUsers from './components/Management/ManageUsers';
// import ManageOrders from './components/Management/ManageOrders';
// import ManageProducts from './components/Management/ManageProducts';
// import ManageDeals from './components/Management/ManageDeals';
// import ManageBrands from './components/Management/ManageBrands';
// import ManageStaff from './components/Management/ManageStaff';
// import ManageHeader from './components/Management/ManageHeader';
// import ManageFooter from './components/Management/ManageFooter';
// import ManageCatalogs from './components/Management/ManageCatalogs';
// import ManageDiscounts from './components/Management/ManageDiscounts';
// import ManagePincode from './components/Management/ManagePincode';
// import './styles/global.css';

// // Protected Route component
// const ProtectedRoute = ({ children }) => {
//   const { isAuthenticated, loading } = useAuth();

//   if (loading) {
//     return <div className="loading">Loading...</div>;
//   }

//   if (!isAuthenticated) {
//     return <Navigate to="/login" />;
//   }

//   return children;
// };

// function App() {
//   return (
//     <div className="App">
//       <Routes>
//         <Route path="/login" element={<Login />} />

//         <Route path="/" element={
//           <ProtectedRoute>
//             <AdminLayout />
//           </ProtectedRoute>
//         }>
//           <Route index element={<Dashboard />} />
//           <Route path="users" element={<ManageUsers />} />
//           <Route path="orders" element={<ManageOrders />} />
//           <Route path="products" element={<ManageProducts />} />
//           <Route path="deals" element={<ManageDeals />} />
//           <Route path="brands" element={<ManageBrands />} />
//           <Route path="staff" element={<ManageStaff />} />
//           <Route path="header" element={<ManageHeader />} />
//           <Route path="footer" element={<ManageFooter />} />
//           <Route path="catalogs" element={<ManageCatalogs />} />
//           <Route path="discounts" element={<ManageDiscounts />} />
//           <Route path="pincode" element={<ManagePincode />} />
//         </Route>

//         <Route path="*" element={<Navigate to="/" />} />
//       </Routes>
//     </div>
//   );
// }

// export default App;


// import React from 'react';
// import { Routes, Route, Navigate } from 'react-router-dom';
// import { useAuth } from './context/AuthContext';
// import Login from './components/Login/Login';
// import AdminLayout from './components/Layouts/AdminLayout';
// import './styles/global.css';

// // Protected Route component
// const ProtectedRoute = ({ children }) => {
//   const { isAuthenticated, loading } = useAuth();

//   if (loading) {
//     return <div className="loading">Loading...</div>;
//   }

//   if (!isAuthenticated) {
//     return <Navigate to="/login" />;
//   }

//   return children;
// };

// function App() {
//   return (
//     <div className="App">
//       <Routes>
//         <Route path="/login" element={<Login />} />

//         <Route
//           path="/"
//           element={
//             <ProtectedRoute>
//               <AdminLayout />
//             </ProtectedRoute>
//           }
//         >
//           {/* You can add working routes here later */}
//         </Route>

//         <Route path="*" element={<Navigate to="/" />} />
//       </Routes>
//     </div>
//   );
// }

// export default App;
import './styles/global.css';
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Login from './components/Login/Login';
import AdminLayout from './components/Layouts/AdminLayout';
import Dashboard from './components/Dashboard'; // Import the Dashboard component
import OfferBannerManager from './components/OfferBannerManager/OfferBannerManager'; // 👈 Import the banner manager
import VendorList from './components/VendorList/VendorList';
import CouponManager from './components/CouponManager/CouponManager';
import CategoryManager from './components/CategoryManager/categoryManager';
import CreateAdmin from './components/CreateAdmin/CreateAdmin';
import UserList from './components/UserManager/userlist';
import OrderList from './components/OrderList/OrderList';
import DeliveryBoyList from './components/DeliveryBoyManager/DeliveryBoyList';
import ProductList from './components/ProductManager/ProductList';

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return children;
};

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} /> {/* Default route within AdminLayout */}
          <Route path="offer" element={<OfferBannerManager />} /> {/* 👈 New route */}
          <Route path="registerlist" element={<VendorList />} /> {/* 👈 New route */}
          <Route path="coupon" element={<CouponManager />} /> {/* 👈 New route */}
          <Route path="category" element={<CategoryManager />} /> {/* 👈 New route */}
          <Route path="create" element={<CreateAdmin />} />
          <Route path="users" element={<UserList />} />
          <Route path="orders" element={<OrderList />} />
          <Route path="delivery-boys" element={<DeliveryBoyList />} />
          <Route path="products" element={<ProductList />} />

        </Route>

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>
  );
}

export default App;
